import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { shortTestimonials } from '../data/content';
export function MoreTestimonials() {
  return <section aria-labelledby="mas-testimonios" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10" data-id="element-194" data-mp="258rw92lcr756">
      <Reveal data-id="element-195" data-mp="2a84efa1a3q1f">
        <h2 id="mas-testimonios" className="text-center font-display text-xl md:text-2xl font-extrabold uppercase text-ink" data-id="element-196" data-mp="2a6jjvkeys73k">
          Personas que ya tienen CM Digital Pro
        </h2>
      </Reveal>

      <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-197" data-mp="1hl9wajrxp2r4">
        {shortTestimonials.map((t, i) => <Reveal key={i} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-xl border border-line bg-surface p-4" data-id="element-198" data-mp="1mkmtnygfls7y" data-mpi={i}>
            <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-199" data-mp="2xzjojozarbn8">
              {Array.from({
            length: 5
          }).map((_, j) => <StarIcon key={j} size={12} className="fill-accent text-accent" data-id="element-200" data-mp="918rdt65snxp" data-mpi={j} />)}
            </div>
            <blockquote className="mt-2.5 text-sm leading-relaxed text-ink" data-id="element-201" data-mp="vtiv1217b">
              “{t.quote}”
            </blockquote>
            <p className="mt-auto pt-3 text-xs font-semibold text-ink-subtle" data-id="element-202" data-mp="3r74wlw0kwr7a">
              — {t.author}
            </p>
          </Reveal>)}
      </ul>
    </section>;
}